import type { AxiosInstance } from 'axios';
import {
  createAuthenticatedAxios,
  getTcmApiBaseUrl,
} from './authAxiosFactory';

/**
 * Axios client for TCM (call-deflection) APIs only.
 * Uses the same Bearer token from localStorage as RM Resource Matrix APIs.
 */
export const tcmApiClient: AxiosInstance =
  createAuthenticatedAxios(getTcmApiBaseUrl());

export default tcmApiClient;
